export default {
  title: "加入等待名单",
  description: "抢先体验我们的高级功能，获得即将发布的新特性的早期访问权限。",
  emailPlaceholder: "请输入邮箱",
  submitButton: {
    default: "加入等待名单",
    submitting: "正在加入...",
  },
  messages: {
    success: "感谢您加入等待名单！我们将尽快与您联系。",
    alreadyExists: "您已经在等待名单中。我们会持续为您推送最新消息。",
    error: "提交失败：请稍后重试。",
    invalidEmail: "请输入有效的邮箱地址。",
    unknownError: "发生未知错误。请稍后重试。",
  },
};
